import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery, QueryOptions } from '../../repository/types'
import type { User } from '../User'

@InputType()
export class GetCollaboratorUsersArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  filter: FilterQuery<User>

  @Field(() => GraphQLJSON)
  options: QueryOptions<User>
}

export interface IGetCollaboratorUsers extends IAction<User[], GetCollaboratorUsersArgs> {}
